import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {TimelineCreatorForm} from '../../timeline/creator/timeline-creator-form';
import type {OwnProps} from '../../timeline/creator/timeline-creator-form';

import {
    setCreatorForm,
    setActivityTypeId,
    setDurationMinutes,
    setPinNote,
    setIsTranscribing,
    resetCreatorFormAfterSubmit,
} from '../redux/core-entity-page-reducer';
import {getCoreEntityPageCreatorForm} from '../redux/core-entity-page-selectors';

export function CoreEntityCreatorForm(props: OwnProps) {
    const creatorForm = useSelector(getCoreEntityPageCreatorForm);
    const dispatch = useDispatch();

    useEffect(() => {
        if (creatorForm.isTranscribing) {
            dispatch(setIsTranscribing(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <TimelineCreatorForm
            {...props}
            htmlValue={creatorForm.noteHtmlValue}
            plaintextValue={creatorForm.notePlaintextValue}
            onChange={(hv, pv) => {
                dispatch(setCreatorForm(hv, pv));
            }}
            activityTypeId={creatorForm.activityTypeId}
            setActivityTypeId={(id) => {
                dispatch(setActivityTypeId(id));
            }}
            durationMinutes={creatorForm.durationMinutes}
            setDurationMinutes={(minutes) => {
                dispatch(setDurationMinutes(minutes));
            }}
            pinNote={creatorForm.pinNote}
            setPinNote={(pinned) => {
                dispatch(setPinNote(pinned));
            }}
            isTranscribing={creatorForm.isTranscribing}
            setIsTranscribing={(transcribing) => {
                dispatch(setIsTranscribing(transcribing));
            }}
            onResetAfterSubmit={() => {
                dispatch(resetCreatorFormAfterSubmit());
            }}
        />
    );
}
